<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div class="MaInput">
    <el-input
      id="input1"
      ref="input"
      size="mini"
      :disabled="canDisable"
      v-model="value1"
      @focus="doFocus"
      @blur="doBlur"
      @input="regrexp(value)"
      @keyup.down.native="downkey($event)"
      @keyup.up.prevent.native="upkey($event)"
      @keyup.enter.native="enterkey($event)"
    >
      <span slot="prefix" class="label_sty">{{labelName}} :</span>
      <span v-if="isMust" slot="prefix" class="ismust_sty">*</span>
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 值字段
      value1: this.value
    };
  },
  props: {
    // 输入框数据
    value: [String, Number],
    labelName: [String],
    // 是否可输入
    reg: {
      type: String,
      default: "text"
    },
    // 是否为必须
    isMust:{
      type: Boolean,
      default: false
    },
    // 是否可以输入、默认可以
    canDisable:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.value1 = this.value;
    },
    value1() {
      this.$emit("dateChange", this.value1);
    },
  },
  methods: {
    // 按上键
    upkey(e) {
      this.$emit("preFocus");
    },
    // 按下键
    downkey(e) {
      this.$emit("nextFocus");
    },
    // 回车回调
    enterkey() {
      this.$emit("nextFocus");
      // this.$refs.input.blur();
    },
    // 输入框输入正则验证input
    regrexp(val) {
      switch (this.reg) {
        case "text":
          break;
        case "float":
          this.value1 = this.value1.replace(
            /^\D*(\d*(?:\.\d{0,6})?).*$/g,
            "$1"
          );
          break;
        case "integer":
          this.value1 = this.value1.replace(/[^\d]/g, "");
          break;
        case "allnumber":
          this.value1 = this.value1.replace(/^[^\-\d]*([\-\d]?\d*(?:\.\d{0,6})?).*$/g, '$1');
          break;
        case "phone":
          // this.value1=this.value1.trim().match(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/);
          break;
        case "idcard":
          break;
        default:
          break;
      }
    },
    // 聚焦触发全输入框内容
    doFocus() {
      event.currentTarget.select();
    },
    // 失去焦点，隐藏选择框
    doBlur() {
      this.rowIndex = 0; //重置索引
    }
  },
  mounted() {},
};
</script>

<style lang="less">
.MaInput {
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }
  .ismust_sty{
    color: red;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 75px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/MaInputThree/MaInputThree.vue